import { useState } from 'react'
import "../Scholarship/Scholarship.scss"
import { Button } from 'primereact/button';
import Footer from "../../Shared-Component/Footer/Footer"
import Header from "../../Shared-Component/Header/Header"
import CampusTitle from "../CampusSharedComponent/CampusTitles/CampusTitle/CampusTitle"


const Scholarship = () => {

    const [showScholarContent, setScholarShowContent] =useState(false)
    const [showMoovaloorContent, setMoovaloorShowContent] = useState(false)
    const [showPudhalvanContent, setShowPudhalvanContent] = useState(false)

    const elegibleData = [
        { title: "SC-GOI-PMSS: ", content: "The Post-Matric Scholarship Scheme for Scheduled Caste students, a centrally sponsored scheme by the Government of India." },
        { title: "SCC-State Special Post Matric Scholarship: ", content: "The State Special Post Matric Scholarship for Scheduled Caste students, a state-level scheme." },
        {title: "ST-GOI-PMSS-Private:", content: "  This scholarship scheme for Scheduled Tribe students, possibly including a     component for private institutions, under the Post-Matric Scholarship Scheme."}
    ]

    const elegibleDataList = [
        { title: "Eligibility: ", content: ["The schemes typically require students to be Indian nationals, belong to the SC/ST/specified categories, and be studying in eligible institutions."] },
        { title: "Benefits: ", content: ["The scholarships can cover tuition fees, maintenance allowances (for hostellers and day scholars), and other expenses."] },
        {title: "Income Limit:", content:["A crucial eligibility criteria is the annual income of the student's family, which usually has an upper limit (e.g., ₹2,50,000 per annum). "]},
        {title: "Note:", content:["The exact details, eligibility criteria, and benefits can vary slightly depending on the specific scheme and the state or region."]}
    ]


    return (
        <>
            <div>
                <Header />

                <div className='campusmaincontainer'>
                    <div className='campus-container' style={{ paddingBottom: "0" }}>
                        <CampusTitle title="Scholarship" />
                        <div className='scholar-content-container'>
                            <h2 className='scholar-content-title'>SC-GOI-PMSS/SCC-State Special Post Matric Scholarship/ST-GOI-PMSS-Private
                            </h2>
                            <p className='scholar-content'>Total Eligible Beneficiary  Students for Academic Year -2024-2025 : 61
                            </p>
                           
                            {
                            (showScholarContent) && <div>
                            {
                                elegibleData &&
                                <div>
                                    {elegibleData.map((item, index) => (
                                        <div key={index}>
                                            <p className='scholar-content title-1'>{item.title}</p>
                                            <li className='scholar-content'>{item.content}</li>
                                        </div>
                                    ))}
                                </div>
                            }

                            {
                                elegibleDataList && 
                                <div>
                                    <h2 className='scholar-content-title' style={{color:"#116c4a"}}>Eligibility and Benefits
                            </h2>
                                    {
                                        elegibleDataList.map((item,index) =>
                                        (
                                            
                                            <div key={index}>
                                                <p className='scholar-content title-2' ><b>{item.title}</b></p>
                                                {
                                                    item.content.map((listitem,listindex) => 
                                                    (
                                                        <ul key={listindex} className="elegible-list">
                                                            <li className='scholar-content'>{listitem}</li>
                                                        </ul>
                                                    )
                                                    )
                                                }
                                            </div>
                                        )
                                        )
                                    }
                                </div>
                            }

                                </div>
                            }

                            <div className='scholar-content-button-container'>
                            <Button label={(!showScholarContent) ? "Know More" : "Know Less"} className='scholar-button' onClick={() => setScholarShowContent(!showScholarContent)} />
                            </div>
                         </div>
                        <div className='scholar-slash'>
                        </div>
                        <div className='scholar-green-content-container'>
                            <h2 className='scholar-green-content-title'>TAMIL PUDHALVAN SCHEME</h2>
                            <p className='scholar-green-content'>Total Eligible Beneficiary  Students for Academic Year -2025-2026 :  134 </p>
                            <p className='scholar-green-content'>Total Eligible Beneficiary  Students for Academic Year -2024-2025 :  143 </p>
                            <p className='scholar-green-content'>Total Eligible Beneficiary  Students for Academic Year -2023-2024 :  87 </p>
                         
                            {
                                (showPudhalvanContent) && 
                                <div>
                                    <ul className='scholar-content' style={{color:'white', paddingLeft:'20px'}}>
                                        <li>The programme aims to provide financial assistance of ₹1,000 per month to boys who have studied in classes 6 to 12 in State-run schools, for pursuing their higher education.</li>
                                        <li>Cash incentive of Rs.1000/month per beneficiary as DBT will be sanctioned till the completion of their first higher education.</li>
                                        <li> This will be paid on a monthly basis to all eligible boy students who have studied from 6th 12th Std. in Government schools and Government aided schools in tamil medium.</li>
                                        <li>The boy students availing other scholarships are also eligible to enroll in this scheme.</li>
                                        <li>This cash incentive extended to any number of boy students in a family pursuing higher education at a recognized Institutions / Colleges / Universities.</li>
                                        <li>The higher education department facilitates opening a 'zero balance' bank account and to certify every six months in a year viz., 30th June and 31st December on the bonafide status of the boy students who had applied.</li>
                                        <li>To open an Aadhaar seeded bank account from any banks to the students wherever necessary furnish the debit card.</li>
                                        <li>The boy students should pursue their education in recognized course and college / universities (only first course of higher education will be considered as an eligible factor)</li>
                                    </ul>
                                </div>
                                }

                            <div className='scholar-green-content-button-container'><Button label={(!showPudhalvanContent) ? "Know More" : "Know Less"} className='scholar-white-button' onClick={() => setShowPudhalvanContent(!showPudhalvanContent)} /></div>
                        </div>
                        <div className='scholar-white-slash'>
                            <ul>
                            </ul>
                        </div>
                        <div className='scholar-content-container'>
                            <h2 className='scholar-content-title' style={{ paddingTop: "2%" }}>MOOVALUR RAMAMIRTHAM AMMAIYAR NINAIVU PUTHUMAI PENN THITTAM</h2>
                            <p className='scholar-content'>Total Eligible Beneficiary  Students for Academic Year -2025-2026 :  54</p> 
                            <p className='scholar-content'>Total Eligible Beneficiary  Students for Academic Year -2024-2025 :  46</p>
                            <p className='scholar-content'>Total Eligible Beneficiary  Students for Academic Year -2023-2024 :  15</p> 
                              
                                                      
                            {(showMoovaloorContent) && 
                            <ul style={{paddingLeft:'20px'}}> 
                                 <li className='scholar-content'>Recognizing that the enrolment ratio of girl students from Government schools in higher education is very low and to promote higher education among girls belonging to the economically weaker families, the Moovalur Ramamirtham Ammaiyar Marriage Assistance scheme shall be transformed as the Moovalur Ramamirtham Ammaiyar Higher Education Assurance Scheme.
                              </li>
                              <li className='scholar-content'> All girl students who studied from Classes 6 to 12 in Government schools will be paid Rs.1,000/- per month directly into their bank account till the uninterrupted completion of their undergraduate degree. The students shall be eligible for this in addition to other scholarships”.
                              </li>
                                </ul>}
                            <div className='scholar-content-button-container'><Button label={(!showMoovaloorContent) ? "Know More" : "Know Less"} className='scholar-button' onClick={() => setMoovaloorShowContent(!showMoovaloorContent)} /></div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}

export default Scholarship